<template>
  <div>
  <form @submit.prevent class="login-form-box login-pagegap forgot-page">
    <div class="logo-img">
      <v-img
        max-height="60"
        max-width="230"
        :src="image_logo"
        :lazy-src="image_logo"
      >
      </v-img>
    </div>
    <h4 class="welcome-text">Forgot Password?</h4>
    <p>Please enter your registered email associated with this account and we will send you the OTP to reset your password.</p><br>
    <v-row>
      <v-col>
        <v-text-field
          class=""
          v-model="email"
          :error-messages="emailErrors"
          label="Email*"
          placeholder = "Enter registered email"
          required
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        ></v-text-field>
        <!-- <em>Please enter your registered email. You will receive an OTP on the same.</em> -->
      </v-col>
    </v-row>
    <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error">{{serverError}}</span>
    <v-row>
      <v-col>
        <v-btn @click="submit" :disabled="!isFormValid" class="blue-btn btn" :error-messages="buttonErrorMessage">
          Reset Password
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
          <v-btn @click="backtologin" class="back-link">
            Back to login
          </v-btn>
      </v-col>
    </v-row>
  </form>
</div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import JwtService from ".././common/jwt.service";

export default {
  mixins: [validationMixin],

  validations: {
    email: { required, email },
  },

  data: () => ({
    email: '',
    submitted: false,
    serverError:'',
    isFormValid:false,
    isAddClassServerError:false,
    image_logo:process.env.VUE_APP_ROOT_ICONS_URL + 'Logo.png',
  }),

  computed: {
    emailErrors() {
      const errors = [];
      this.serverError='';
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid email");
      !this.$v.email.required && errors.push("Email is required");
      return errors;
    },
    buttonErrorMessage(){
      if (this.$v.$invalid) {
          this.isFormValid = false;
        }else{
          this.isFormValid = true;
        }
    }
  },

  methods: {
    submit(e) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.isFormValid = false;
      this.$loading(true)
      const email = this.email;
      Auth.forgotPassword(email)
      .then(data => {
        let user_data = { 
          email: this.email,  
        };
        this.updateAuthUser('commitData', user_data)
        // localStorage.setItem("email", this.email);
        this.$loading(false)
        this.$router.push({ name: 'ConfirmNewPassword' }).catch(()=>{})
      })
      .catch((error) => {
          this.isAddClassServerError = true;
          this.isFormValid = true;
         this.serverError  = error.message; 
         this.$loading(false);
      });
    },
    backtologin(evt){
      evt.preventDefault();
      this.$router.push({ name: 'Login' }).catch(()=>{});
    }
  }
};
</script>